/** @format */
import React from 'react';

export default ({onPress, onClick, children}) => {
  return React.cloneElement(children, {onClick: onClick || onPress});
};
